<div class="common-modal__container">
    <div class="common-modal__header">
      <span class="common-modal__text-header common-modal__text-header-flex-none"
        [afTranslate]="'generate-document.export-data'">
        _Exportar datos a plantilla
      </span>
    </div>
    <div class="common-modal__content-scroll">
        <p class="common-modal__content-header-info">
            {{generateDocument.textInfoTemplate}}
        </p>
    </div>
    <div class="common-modal__content">
        <form class="common-modal__form-container">
            <div class="common-container__mandatory-obligatory-message-form">
            <span class="common-tag__mandatory-text-asterisk">*</span>
            <span class="common-tag__mandatory-label-text-obligatory-message"
                [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
            </div>
            <field-type-text-simple [field]="generateDocument.documentName"
                [preSelectItem]="predefinedTemplate.predefinedName"
                (itemSelected)="itemSelected($event, 'name')">
            </field-type-text-simple>
        </form>
    </div>
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">
          _Cancelar
        </span>
      </button>
      <button class="common-button__text"
        (click)="validateFields()">
        <span class="common-button__text-title"
          [afTranslate]="'common.export'">
          _Exportar
        </span>
      </button>
    </div>
</div>
